class Notifications {
  constructor() {}
  // container is where on screen the notification appears, for example
  // "top-center". It defaults to the top right corner.
  addNotification = (title, message, type, container) => {
    document.dispatchEvent(
      new CustomEvent("notification_add", {
        detail: {
          title: title,
          message: message,
          type: type,
          container: container,
        },
      })
    );
  };
}

export default new Notifications();
